export const FORM_CONSTANTS = {
  RULE_TYPES: {
    SHOPPING_ACTIVITY: "shopping-activity",
    ASSIGNED_AUDIENCE: "assigned-audience",
    MARKETING_ACTIVITY: "marketing-activity",
    CLEANED_CUSTOMER: "cleaned-customer",
  },
  SOURCES: {
    SHOPIFY: "SHOPIFY",
    TINYEMAIL: "TINYEMAIL",
    TINYALBERT: "TINYALBERT",
  },
  EVENTS: {
    CHECKOUT_STARTED: "CHECKOUT_STARTED",
    ORDER_PLACED: "ORDER_PLACED",
    ORDER_FULFILLED: "ORDER_FULFILLED",
    CUSTOMER_ASSIGNED_TO_SEGMENT: "CUSTOMER_ASSIGNED_TO_SEGMENT",
    CLEANED_CUSTOMER: "CLEANED_CUSTOMER",
    CLICK: "CLICK",
    OPEN: "OPEN",
  },
  ACTIVITY_TYPES: {
    CAMPAIGN: "CAMPAIGN",
    WORKFLOW: "WORKFLOW",
  },
  FROM_VALUES: {
    START_OF_WORKFLOW: "start-of-workflow",
    ANYTIME: "anytime",
  },
  PAGE_SIZE: 10,
};

export const RULE_TYPE_OPTIONS = [
  {
    value: FORM_CONSTANTS.RULE_TYPES.SHOPPING_ACTIVITY,
    label: "Shopping Activity",
    active: true,
  },
  {
    value: FORM_CONSTANTS.RULE_TYPES.ASSIGNED_AUDIENCE,
    label: "Assigned to the Audience",
    active: true,
  },
  {
    value: FORM_CONSTANTS.RULE_TYPES.MARKETING_ACTIVITY,
    label: "Marketing Activity",
    active: true,
  },
  {
    value: FORM_CONSTANTS.RULE_TYPES.CLEANED_CUSTOMER,
    label: "Cleaned Customer",
    active: true,
  },
];

export const SOURCE_OPTIONS = [
  { value: FORM_CONSTANTS.SOURCES.SHOPIFY, label: "Shopify" },
];

export const EVENT_TYPE_OPTIONS = [
  { value: FORM_CONSTANTS.EVENTS.CHECKOUT_STARTED, label: "Checkout Started" },
  { value: FORM_CONSTANTS.EVENTS.ORDER_PLACED, label: "Order Placed" },
  { value: FORM_CONSTANTS.EVENTS.ORDER_FULFILLED, label: "Order Fulfilled" },
];

export const EVENT_TYPE_OPTIONS_MARKETING = [
  { value: FORM_CONSTANTS.EVENTS.CLICK, label: "Click" },
  { value: FORM_CONSTANTS.EVENTS.OPEN, label: "Open" },
];

export const API_DOCS_LINKS: { [ruleType: string]: string } = {
  [FORM_CONSTANTS.RULE_TYPES.ASSIGNED_AUDIENCE]:
    "https://docs.tinyrelay.com/docs/tiny-email/update-audience",
  [FORM_CONSTANTS.RULE_TYPES.CLEANED_CUSTOMER]:
    "https://docs.tinyrelay.com/docs/tiny-email/clean-audience-list",
};

export const ACTIVITY_TYPE_OPTIONS = [
  { value: FORM_CONSTANTS.ACTIVITY_TYPES.CAMPAIGN, label: "Campaign" },
  { value: FORM_CONSTANTS.ACTIVITY_TYPES.WORKFLOW, label: "Workflow" },
];
